import { beHttp } from './beHttp';

/**
 * Integración con Google Calendar (fase 1, detrás de feature flag) — vive en
 * psiplatform-be, no en api-core (consentimiento OAuth propio, separado del login).
 * Ver psiplatform-be/src/modules/google-calendar.
 */

export interface GoogleCalendarStatus {
  /** false si el interruptor maestro del feature está apagado en el backend. */
  enabled: boolean;
  connected: boolean;
  googleEmail: string | null;
  connectedAt: string | null;
  lastOutboundSyncAt: string | null;
  lastSyncError: string | null;
}

const BASE_PATH = '/api/psychologist/integrations/google-calendar';

export async function getGoogleCalendarStatus(): Promise<GoogleCalendarStatus> {
  return beHttp.get<GoogleCalendarStatus>(`${BASE_PATH}/status`, undefined, {
    showErrorToast: false,
  });
}

/** Devuelve la URL de consentimiento de Google — el caller navega con `window.location.href`. */
export async function getGoogleCalendarConnectUrl(): Promise<{ url: string }> {
  return beHttp.get<{ url: string }>(`${BASE_PATH}/connect`, undefined, {
    errorMessage: 'No se pudo iniciar la conexión con Google Calendar',
  });
}

export async function disconnectGoogleCalendar(): Promise<{ success: true }> {
  return beHttp.post<{ success: true }>(`${BASE_PATH}/disconnect`, undefined, {
    errorMessage: 'No se pudo desconectar Google Calendar',
  });
}
